import {
    useMemo, useState,
} from 'react'

import Card from 'app/shared-components/Card'
import useHasPermission from 'app/hooks/useHasPermission'
import RichTable from 'app/shared-components/RichTableReduxWrapper'
import request from 'app/requests/RegionalGroup.requests'
import useLoadFilters from 'app/common/DomainObject/hooks/useLoadFilters'
import CollapsableAddRemovePanel from 'app/shared-components/CollapsableAddRemovePanel'
import useStyles from 'app/shared-components/RichTableWithAddIcon/RichTableWithAddIcon.style'

import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'

import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    TableResponse,
} from 'app/types/request.types'
import useRequestTable from 'app/hooks/useRequestTable'
import {
    RegionalGroupFilterRequestResponse,
} from '../../RegionalGroups/regionalGroups.types'
import columns from './regionalGroups.columns'
import RegionalGroupCreateForm from './RegionalGroupCreateForm'

const RegionalGroups = ({
    id,
}: { id: number }) => {
    const {
        classes,
    } = useStyles()
    const {
        RegionalGroups: RegionalGroupsRoutes,
    } = useAccountManagementRoutes()

    const defaultFilter = useMemo(() => {
        return {
            accountId: [id],
        }
    }, [id])

    const [
        createFormOpened,
        setCreateFormOpened,
    ] = useState<boolean>(false)

    const accountCreate = useHasPermission(['account_create_all'])
    const {
        onParamsChange,
        loadData,
        invalidate,
    } = useRequestTable<TableResponse<RegionalGroupFilterRequestResponse>>({
        config: request[RequestKeys.regionalGroupsFilterRequest],
        params: {},
        defaultValue: {
            filter: defaultFilter,
        },
        key: RequestKeys.regionalGroupsFilterRequest,
    })

    const injectLoadFilters = useLoadFilters(
        request.FilterCountRequest(),
    )

    const columnsWithFilters = useMemo(() => {
        return injectLoadFilters(columns)
    }, [injectLoadFilters])

    const onRowClick = ({
        id: idRegionalGroup,
    }: { id: number }) => {
        RegionalGroupsRoutes.Overview.navigate({
            params: {
                key: idRegionalGroup,
            },
        })
    }

    const closeCreateForm = (): void => {
        setCreateFormOpened(false)
    }

    const openCreateForm = (): void => {
        setCreateFormOpened(true)
    }

    const onSuccess = () => {
        closeCreateForm()
        invalidate()
    }

    return (
        <Card
            fullHeight
            contentClass={classes.cardContent}
            data-testid="RegionalGroupsTable-card"
        >
            <CollapsableAddRemovePanel
                title="Regional Groups"
                onOpenForm={openCreateForm}
                onCloseForm={closeCreateForm}
                formOpened={createFormOpened}
                disabled={!accountCreate}
            >
                <RegionalGroupCreateForm
                    accountId={id}
                    onSuccess={onSuccess}
                />
            </CollapsableAddRemovePanel>
            <RichTable
                configName="RegionalGroupsTable"
                name={request.domainName}
                load={loadData}
                onParamsChange={onParamsChange}
                columns={columnsWithFilters}
                className={classes.tableContent}
                classNames={{
                    contentWrapper: classes.tableContentWrapper,
                }}
                filter={defaultFilter}
                onRowClick={onRowClick}
            />
        </Card>
    )
}

export default RegionalGroups
